// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"n6-z","colorTextValue":"o6-z","swatches":"p6-z","collapseLink":"q6-z","isCollapsed":"r6-z","dropdown":"s6-z","disabled":"t6-z"};